// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerSelectorStyles } from "@insite/content-library/Components/CustomerSelector";
import { TypographyPresentationProps } from "@insite/mobius/Typography";

const textStyles: TypographyPresentationProps = {
    color: "text.main",
};

const linkTextStyles: TypographyPresentationProps = {
    color: "text.link",
};

customerSelectorStyles.customerCardSelected = {
    address: {
        attentionText: textStyles,
        customerNameText: textStyles,
        companyNameText: textStyles,
        address1Text: textStyles,
        address2Text: textStyles,
        address3Text: textStyles,
        address4Text: textStyles,
        cityStatePostalCodeText: textStyles,
        countryText: textStyles,
        phoneText: textStyles,
        emailText: linkTextStyles,
        faxText: textStyles,
    },
};
